import axios from "../utils/axios";

const request = async (method, { url, body, responseType, headers }) => {

  try {
    const config = { 
      responseType, 
      headers: headers || {}  // Ensure headers are set
    };


    const isBodyAllowed = ["post", "put", "patch"].includes(method);
    const { data } = isBodyAllowed 
      ? await axios[method](url, body, config) 
      : await axios[method](url, config);

    return {
      status: 200,
      data,
    };
  } catch (error) {
    console.error("Axios Error:", error); // Log the error for debugging
    throw new Error(error?.message || "Something went wrong!");
  }
};

export const GET = async ({ url,  headers, responseType = "json" }) =>  
  request("get", { url, headers, responseType });

export const POST = async ({ url, body,  headers, responseType = "json" }) => 
  request("post", { url, body, responseType, headers });

export const PATCH = async ({ url, body,  headers, responseType = "json" }) => 
  request("patch", { url, body, responseType, headers });

export const DELETE = async ({ url, body,  headers, responseType = "json" }) => 
  request("delete", { url, body, responseType, headers });

export const PUT = async ({ url, body,  headers, responseType = "json" }) => 
  request("put", { url, body, responseType, headers });
